"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const web3_1 = __importDefault(require("web3"));
function convertBep20ToStellarMemo(address) {
    if (!web3_1.default.utils.isAddress(address)) {
        throw Error('BEP20 Address is not valid');
    }
    return Buffer.from(address.replace('0x', ''), 'hex').toString('base64');
}
exports.convertBep20ToStellarMemo = convertBep20ToStellarMemo;
//# sourceMappingURL=bscService.js.map